import { ListHeader } from 'components/molecules/ListHeader';

export const EnvironmentListHeader = () => (
  <ListHeader
    columns={['環境名', 'コンポーネント名（バージョン）']}
    templateColumns="2fr 10fr"
  />
);
